import Icon from '../../DataDisplay/Icon/Icon.js';
import React__default, { useRef } from 'react';
import useClickOutside from '../../Hooks/useClickOutside/useClickOutside.js';
import 'copy-to-clipboard';
import '../../Hooks/useDateTimeFormat/useDateTimeFormat.js';
import 'use-debounce';
import '../../Hooks/useFromNow/useFromNow.js';
import 'crypto-js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-3LPAMF3R.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-LSZKOVGW.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-GTEBSQTL.js';
import 'react-router-dom';
import '../../Providers/LanguageProvider/LanguageProvider.js';
import '@azure/msal-react';
import Backdrop from '../../Layout/Backdrop/Backdrop.js';
import classNames from 'classnames';
import styles from './Drawer.module.scss.js';

const Drawer = ({ width = 300, height = '100%', fromRight = false, children, isScrollable = true, isOpen, setIsOpen, onClose, showCloseButton = false, closeOnClickOutside = false, backgroundColor = '#FFFFFF', backdropColor = 'light', showBackdrop = true, forceReloadWhenOpen = false, showShadow = true, }) => {
    const position = fromRight ? 'Right' : 'Left';
    const ref = useRef(null);
    const handleClose = () => {
        setIsOpen(false);
    };
    useClickOutside(ref, handleClose, isOpen && closeOnClickOutside);
    /*  const handleTransitionEnd = () => {
        if (ref.current) {
        if (!isOpen) {
          setHidden(false)
        } else {
          setHidden(true)
        }
      }
    };
   */
    const drawerStyle = {
        position: 'fixed',
        width: width,
        height: height,
        zIndex: 11000,
        overflow: isScrollable ? 'auto' : undefined,
        backgroundColor: backgroundColor,
        transform: isOpen
            ? `translateX(0)`
            : `translateX(${fromRight ? '100%' : '-105%'})`,
        transition: 'transform 0.3s ease',
        borderRight: 'solid 1px #ededed',
        boxShadow: showShadow ? '0px 0px 10px rgba(0, 0 , 0, 0.15)' : undefined,
    };
    const CloseIcon = () => {
        return (React__default.createElement("div", { onClick: handleClose, style: {
                position: 'absolute',
                right: 0,
                top: 0,
                padding: 5,
                cursor: 'pointer',
                fontSize: 10,
                color: '#CCCCCC',
                zIndex: 5,
            } },
            React__default.createElement(Icon, { icon: "IconClose", iconSize: 0.6, color: "#CCCCCC" })));
    };
    return (React__default.createElement(React__default.Fragment, null,
        showBackdrop ? (React__default.createElement(Backdrop, { backgroundColor: backdropColor, isShown: isOpen })) : null,
        React__default.createElement("div", { ref: ref },
            React__default.createElement("div", { className: classNames(styles.drawer, styles[`drawer${position}`]), style: drawerStyle, key: isOpen && forceReloadWhenOpen ? Date.now() : 'drawer' },
                showCloseButton ? React__default.createElement(CloseIcon, null) : null,
                children))));
};

export { Drawer as default };
//# sourceMappingURL=Drawer.js.map
